
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Eye } from "lucide-react";

interface OrdersTabProps {
  orders: any[];
  onViewDetails: (order: any) => void;
}

export const OrdersTab = ({ orders, onViewDetails }: OrdersTabProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Tarih</TableHead>
          <TableHead>İsim</TableHead>
          <TableHead>Email</TableHead>
          <TableHead>Tutar</TableHead>
          <TableHead>Durum</TableHead>
          <TableHead>Detay</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {orders.map((order) => (
          <TableRow key={order.id}>
            <TableCell>{new Date(order.created_at).toLocaleDateString('tr-TR')}</TableCell>
            <TableCell>{order.name_surname}</TableCell>
            <TableCell>{order.email}</TableCell>
            <TableCell>{order.amount} TL</TableCell>
            <TableCell>{order.status}</TableCell>
            <TableCell>
              <Button
                variant="ghost"
                size="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  onViewDetails(order);
                }}
              >
                <Eye className="h-4 w-4" />
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
